import intelLogo from "@/assets/intel-logo.png";
import hsbcLogo from "@/assets/hsbc-logo.png";
import aiaLogo from "@/assets/aia-logo.png";
import dbsLogo from "@/assets/dbs-logo.png";
import ocbcLogo from "@/assets/ocbc-logo.png";
import cuhkLogo from "@/assets/cuhk-logo.png";
import hkustLogo from "@/assets/hkust-logo.png";
import masseyLogo from "@/assets/massey-logo.png";
import aucklandLogo from "@/assets/auckland-university-logo.svg";
import polyuLogo from "@/assets/polyu-logo.png";
import iveyLogo from "@/assets/ivey-logo.jpg";

import { useLanguage } from "@/i18n/LanguageContext";

const LogoStrip = () => {
  const { t } = useLanguage();

  const corporateLogos = [
    { src: intelLogo, alt: "Intel", size: "h-24" },
    { src: hsbcLogo, alt: "HSBC", size: "h-8" },
    { src: aiaLogo, alt: "AIA", size: "h-16" },
    { src: dbsLogo, alt: "DBS", size: "h-8" },
    { src: ocbcLogo, alt: "OCBC", size: "h-24" },
  ];

  const academicLogos = [
    { src: aucklandLogo, alt: "University of Auckland", size: "h-8" },
    { src: cuhkLogo, alt: "Chinese University of Hong Kong", size: "h-24" },
    { src: iveyLogo, alt: "Ivey Business School", size: "h-8" },
    { src: hkustLogo, alt: "HKUST", size: "h-24" },
    { src: masseyLogo, alt: "Massey University", size: "h-24" },
    { src: polyuLogo, alt: "Hong Kong Polytechnic University", size: "h-8" },
  ];

  return (
    <section className="py-16 bg-secondary/20 border-y border-border/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
        {/* Corporate Experience */}
        <div>
          <p className="text-center text-xs text-muted-foreground mb-6 tracking-widest uppercase">
            {t("logos.corporate")}
          </p>
          <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12 lg:gap-16">
            {corporateLogos.map((logo) => (
              <div 
                key={logo.alt} 
                className={`grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-300 flex items-center justify-center ${logo.size}`}
              >
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className="h-full w-auto object-contain"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Academic Affiliations */}
        <div>
          <p className="text-center text-xs text-muted-foreground mb-6 tracking-widest uppercase">
            {t("logos.academic")}
          </p>
          <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12 lg:gap-16">
            {academicLogos.map((logo) => (
              <div 
                key={logo.alt} 
                className={`grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-300 flex items-center justify-center ${logo.size}`}
              >
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className="h-full w-auto object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogoStrip;